import { render, staticRenderFns } from "./DepartmentSelect.vue?vue&type=template&id=c526bb7c&scoped=true"
import script from "./DepartmentSelect.vue?vue&type=script&lang=js"
export * from "./DepartmentSelect.vue?vue&type=script&lang=js"
import style0 from "./DepartmentSelect.vue?vue&type=style&index=0&id=c526bb7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c526bb7c",
  null
  
)

export default component.exports